module.exports = "\r\n<div class=\"button\" >\r\n  <robin-button [text]=\"'שלח הזמנה'\" [color]=\"'blue'\" (click)=\"sendContacts()\"></robin-button>\r\n</div>"